<template>
<div>
  <!-- 【1607】这里展示H5页面，原页面隐藏 -->
  <div class="view-main" v-if="false">
    <div class="view-detail">
      <p class="p-title">
        <i class="fenge"></i>
        合同列表
        <span class="temp"
          >共 <span class="tempNo">{{ contractList.length }}</span> 份</span
        >
      </p>
      <ul class="contract-list">
        <li
          v-for="(item, index) in contractList"
          :key="index"
          @click="showDetail(item,index)"
        >
          <img v-show="!item.read" src="/images/weidu.png" alt="" />
          <img v-show="item.read" src="/images/yidu.png" alt="" />
          <!-- <p>{{ item.contractName || "合同名称" }}</p> -->
        </li>
      </ul>
    </div>
    <div class="option-main" v-show="!unableSign">
      <div class="sign-footer" @click="getQrcode()">
        <div class="sign-btn">立即签署</div>
      </div>
    </div>
    <!--本页登录-->
    <el-dialog
      v-if="signInfo"
      :visible.sync="signLoginInfo.visibleSignLogin"
      :close-on-click-modal="false"
      modal-append-to-body
      width="550px"
      :show-close="false"
      class="sign-login"
    >
      <div class="dialog-box">
        <div class="nav-bar">
          <template v-if="signInfo.mobileList && signInfo.mobileList.length">
            <a
              @click="switchSignLoginType('mobile')"
              :class="signLoginInfo.navBar === 'mobile' ? 'active' : ''"
              href="javascript:void (0)"
              >手机验证</a
            >
          </template>
          <template v-if="signInfo.emailList && signInfo.emailList.length">
            <a
              @click="switchSignLoginType('email')"
              :class="signLoginInfo.navBar === 'email' ? 'active' : ''"
              href="javascript:void (0)"
              >邮箱验证</a
            >
          </template>
        </div>
        <el-form
          :model="signLoginInfo"
          size="small"
          label-width="120px"
          class="sign-login__form"
        >
          <el-form-item label-width="80px">
            <h5>为保障您的签署安全，请输入验证码。</h5>
          </el-form-item>
          <template v-if="signLoginInfo.navBar === 'mobile'">
            <el-form-item label="手机号">
              <el-select
                @change="handleSignLoginUserChange('mobile')"
                v-model="signLoginInfo.mobilePhone"
                class="select"
              >
                <template
                  v-if="signInfo.mobileList"
                  v-for="(item, i) in signInfo.mobileList"
                >
                  <el-option
                    :key="i"
                    :value="item.mobile"
                    :label="item.mobile"
                  />
                </template>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="signLoginInfo.navBar === 'email'">
            <el-form-item label="邮箱">
              <el-select
                @chage="handleSignLoginUserChange('email')"
                v-model="signLoginInfo.email"
                class="select"
              >
                <template
                  v-if="signInfo.emailList"
                  v-for="(item, i) in signInfo.emailList"
                >
                  <el-option :key="i" :value="item.email" :label="item.email" />
                </template>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item v-if="signLoginInfo.isImgCode" label="图形验证码">
            <el-row>
              <el-col :span="12">
                <el-input
                  v-model="signLoginInfo.imgCode"
                  placeholder="图形验证码"
                />
              </el-col>
              <el-col :span="9" :offset="3">
                <img-auth
                  ref="refreshQRCode00"
                  size="small"
                  :verify-type="20"
                  :img-token.sync="signLoginInfo.imgToken"
                />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码">
            <el-row>
              <el-col :span="12">
                <el-input
                  v-model="signLoginInfo.valicode"
                  placeholder="验证码"
                />
              </el-col>
              <el-col :span="9" :offset="3">
                <el-button
                  @click="signLoginSendCode"
                  :disabled="countdownInfo.start"
                  type="success"
                >
                  <template v-if="countdownInfo.start">
                    <countdown
                      @on-finish="handleCountdownFinish"
                      v-model="countdownInfo.time"
                      :start="countdownInfo.start"
                    />
                  </template>
                  <template v-else>发送验证码</template>
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="protocol">
            <el-checkbox :checked="true" v-model="checked">
              <span style="color: #666666">我已阅读</span>
              <a
                class="showAgreement"
                style="color: #409eff"
                href="javascript:void(0)"
                @click="showServiceProtocol = true"
                >《君子签服务协议》</a
              >
            </el-checkbox>
          </el-form-item>
          <el-form-item class="text-center">
            <el-button
              @click="userSignLoginCheck"
              type="danger"
              class="btn__submit"
              >开始签署</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!--添加现场二维码-->
    <el-dialog :visible.sync="visibleQrcode" width="340px" class="add-enidence">
      <qrcode-vue :value="qrcodeUrl" :size="300" leave="H" key="evidence" />
      <p class="text-center" style="font-size: 12px; margin: 0">
        请扫码在手机上完成签署
      </p>
    </el-dialog>
    <service-protocol :visible.sync="showServiceProtocol"></service-protocol>
  </div>
  <div class="view-main-h5">
    <iframe 
      :src="`${GlobalConfig.domain.junziqianH5Op}/derong/signInfo/viewDetail_new?${qs.stringify(query)}`"
      class="iframe-sty"
      frameborder
      >
    </iframe>
    <el-dialog
      :visible.sync="preVisi"
      width="60%"
      class="pre-img-box-sty"
    >
    <div class="dia-body">
      <template v-for="(img,i) of preImgUrlList">
        <img :key="i" :src="img.url" class="pre-img" />
        <p :key="i" class="page-item">{{`${img.page} / ${preImgUrlList.length}`}}</p>
      </template>
    </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import GlobalConfig from '@/assets/js/config/global';
import Cookie from "@/assets/js/lib/cookie";
import QrcodeVue from 'qrcode.vue';
import ServiceProtocol from '@/components/protocol/Service';
import SignContract from '@/assets/js/http-serve/signInfoController';
import Countdown from '@/components/countdown/index';
import ImgAuth from '@/components/img-auth/img-auth';
import { isInDingTalk } from '@/assets/js/utils/ding-env'
import qs from 'qs'
const base64 = require('js-base64').Base64;
export default {
  name: "view-detail",
  layout: "user",
  components: { QrcodeVue, ServiceProtocol, Countdown, ImgAuth },
  data () {
    return {
      qs,
      preVisi:false,
      preImgUrlList:[],
      GlobalConfig,
      iframeVisible: false,
      contractList: [{}],
      showContract: false,
      handChapteInfo: null,
      evidenceTitle: "",
      query: null,
      authType: null,
      currentTitle: "",
      unableSign: false,
      showAuthInputDialog: false,
      forceEvidence: 0,
      changeNum: 0,
      // 阅读时间，是否强制阅读所有合同
      readTime: 0,
      visibleQrcode: null,
      qrcodeUrl: null,
      // 943新增
      // 签署信息
      signInfo: null,
      // 签字密码验证
      signPwdForm: { showSignPwd: false, pwd: '', imgCode: '', imgToken: '' },
      // 本页登录，签署登录信息
      signLoginInfo: {
        mobilePhone: null,
        email: '',
        valicode: '',
        userId: '',
        visibleSignLogin: false,
        navBar: 'mobile',
        imgCode: '',
        imgToken: '',
        isImgCode: false,
      },
      countdownInfo: { time: 120, start: false }, // 密码验证倒计时信息
      // 君子签服务协议
      showServiceProtocol: false,
      checked: true,
      signUrl: null,
    };
  },

  created () {
    this.query = this.$route.query;
    this.signUrl = this.query;
    // this.getApiBatchInfo();
  },
  mounted () {
    const _this = this
    // this.doIt();
    const {query} = _this.$route
    console.log('query',query);
    // if([17,20,'17','20'].includes(query.applySignDealType)) this.$message.warning('点击立即签署时，会一键签署列表所有合同')
    window.addEventListener('message',function(e){
      const data = e.data
      if(Array.isArray(data)&& data.length){
        _this.preImgUrlList=data
        _this.preVisi=true
      }
    })
  },
  computed: {
    // 阅读时间，是否强制阅读所有合同
    isNeedRead () {
      return this.readTime && this.readTime > 0;
    },
  },
  methods: {
    /* 943 新增验证*/
    // 本页登录
    userSignLoginCheck () {
      if (!this.checked) {
        this.$message.error('请先同意《君子签服务协议》');
        return;
      }
      let param = {
        bsNo: this.signUrl.bsNo,
        mId: this.signUrl.mId,
        iden: this.signUrl.iden,
        mobilePhone: this.signLoginInfo.mobilePhone,
        email: this.signLoginInfo.email,
        valicode: this.signLoginInfo.valicode,
        userId: this.signLoginInfo.userId,
      };
      SignContract.postApiUserSignLogin(param).then((data) => {
        localStorage.setItem('JZQ_SIGN_TOKEN', data.data);
        this.signLoginInfo = {
          mobilePhone: null,
          email: '',
          valicode: '',
          userId: '',
          visibleSignLogin: false,
          navBar: 'mobile',
          imgCode: '',
          imgToken: '',
          isImgCode: false,
        };
        this.setToken(data.data);
        this.query.checkState = 1
        this.getApiBatchInfo();
      }).catch(err => {
        if (err.code == 10601) {
          this.addImgCode();
        } else {
          this.$message.warning(err.description || '安全验证失败');
        }
      });
    },
    checkSignLogin (data) {
      if (data.loginFlag) {
        // 验证登录状态 1免登陆;2本页登录;3子账户跳转登录;4跳转注册;5本页签字密码校验;6跳转高级认证;7指定账户登录
        switch (data.loginFlag) {
          case 1: // 免登陆
            if (data.signToken) {
              localStorage.setItem('JZQ_SIGN_TOKEN', data.signToken);
              this.setToken(data.signToken);
            }
            this.getApiBatchInfo();
            break;
          case 2: // 本页登录
            if (data.mobileList) {
              this.signLoginInfo.navBar = 'mobile';
              this.signLoginInfo.mobilePhone = data.mobileList[0].mobile;
              this.signLoginInfo.userId = data.mobileList[0].userId;
            } else {
              this.signLoginInfo.navBar = 'email';
              this.signLoginInfo.email = data.emailList[0].email;
              this.signLoginInfo.userId = data.emailList[0].userId;
            }
            this.signLoginInfo.visibleSignLogin = true;
            break;
          case 3:  // 跳转登录
          case 6:
            this.$router.push({ path: getLoginPath(data.inviteCode), query: { si: data.inviteCode } });
            break;
          case 4:  // 跳转注册
            this.$router.push({ path: '/account/register', query: { si: data.inviteCode } });
            break;
          case 5:
            this.signPwdForm.showSignPwd = true;
            break;
          case 7:
            if (!data.emailList && !data.mobileList) {
              this.gotoRegister(data);
              break;
            }
            this.signAuthChoose.emailList = data.emailList;
            this.signAuthChoose.mobileList = data.mobileList;
            this.signAuthChoose.userType = data.userType;
            this.signAuthChoose.show = true;
            break;
          default:
            break;
        }
      } else { // 登录成功，获取合同信息
        this.getApiBatchInfo();
      }
    },
    // 本页登录发送验证码
    signLoginSendCode () {
      if (this.signLoginInfo.isImgCode) {
        if (!this.signLoginInfo.imgCode) {
          this.$message.warning('请输入图形验证码');
          return;
        }
      }
      this.countdownInfo.start = true;
      let param = {
        targetId: this.signLoginInfo.navBar === 'email' ? this.signLoginInfo.email : this.signLoginInfo.mobilePhone,
        verifyType: 20,
        imgCode: this.signLoginInfo.isImgCode ? `${this.signLoginInfo.imgToken}_${this.signLoginInfo.imgCode}` : '',
        ifDecode: 0,
        bsNo: this.signUrl.bsNo,
        mId: this.signUrl.mId,
        iden: this.signUrl.iden,
        sign: this.signUrl.sign,
        ts: this.signUrl.ts,
      };
      SignContract.postApiUserSignSendCode(param).then((data) => {
        if (!data.success) {
          this.$message.warning(data.description || '验证码发送失败');
        } else {
          this.countdownInfo = { time: 120, start: true };
        }
      }).catch((err) => {
        this.countdownInfo.start = false;
        if (err.code === '10103' || err.code === '10504') {
          this.addImgCode();
        } else {
          this.$message.warning(err.description || '验证码发送失败');
          this.$refs.refreshQRCode00.getImgAuth();
        }
      });
    },
    // 添加本页登录签署图形验证码
    addImgCode () {
      this.signLoginInfo.isImgCode = true;
      this.signLoginInfo.valicode = '';
      this.signLoginInfo.imgCode = '';
      this.handleCountdownFinish();
    },
    // 本页登录验证码倒计时结束
    handleCountdownFinish () {
      this.countdownInfo = { time: 120, start: false };
    },
    // 设置token
    setToken (token) {
      let tokenStore = this.$store.getters.token;
      tokenStore = tokenStore ? JSON.parse(base64.decode(tokenStore)) : {};
      tokenStore['st'] = token;
      tokenStore = base64.encode(JSON.stringify(tokenStore));
      this.$store.dispatch('setAuthToken', tokenStore);
    },
    handleSignLoginUserChange (navBar) {
      if (navBar === 'email') {
        this.signInfo.emailList.forEach(t => {
          if (this.signLoginInfo.email === t.email) this.signLoginInfo.userId = t.userId;
        });
      } else {
        this.signInfo.mobileList.forEach(t => {
          if (this.signLoginInfo.mobilePhone === t.mobile) this.signLoginInfo.userId = t.userId;
        });
      }
    },
    // 本页登录验证方式切换（手机、邮箱）
    switchSignLoginType (navType) {
      this.signLoginInfo.navBar = navType;

      if (navType === 'email') {
        this.signLoginInfo.mobilePhone = '';
        this.signLoginInfo.email = this.signInfo.emailList[0].email;
        this.signLoginInfo.userId = this.signInfo.emailList[0].userId;
      } else {
        this.signLoginInfo.email = '';
        this.signLoginInfo.mobilePhone = this.signInfo.mobileList[0].mobile;
        this.signLoginInfo.userId = this.signInfo.mobileList[0].userId;
      }
    },
    // ......................20201105 新增本地存储合同已读信息功能 start............................
    /**
     *  存储当前流水号对应的某个合同signNo
     *  存储格式：{bsNo:[signNo1,signNo2]}  流水号:[合同标志signNo]
     *  @bsNo 当前流水号
     *  @signNo 当前流水号已经阅读过的合同signNo
     * */
    setContractReaded (bsNo, signNo) {
      if (!bsNo) return;
      let key = "CONTRACTREAD";
      let objAll = this.getContractReaded(bsNo);
      let current = objAll[bsNo];
      current = current ? current : [];
      if (!current.length || current.indexOf(signNo) == -1) {
        // 标记当前合同为已阅读
        current.push(signNo);
        objAll[bsNo] = current;
        if (window.localStorage && window.localStorage.setItem) {
          window.localStorage.setItem(key, JSON.stringify(objAll));
        } else {
          Cookie.set(key, JSON.stringify(objAll));
        }
      }
    },
    /**
     *  获取合同阅读信息
     * */
    getContractReaded () {
      let key = "CONTRACTREAD";
      let str = "";
      if (window.localStorage && window.localStorage.getItem) {
        str = window.localStorage.getItem(key);
      } else {
        str = Cookie.get(key);
      }
      return str ? JSON.parse(str) : {};
    },
    // ......................20201105 新增本地存储合同已读信息功能 end............................

    addState (val) {
      this.changeNum = this.changeNum + 1;
      window.history.pushState(
        { target: val, random: Math.random() },
        "",
        location.href
      );
    },
    removeState () {
      this.changeNum = this.changeNum - 1;
    },

    //实际的拦截操作
    doIt () {
      //此处添加500毫秒延迟，目的是等待历史记录变化之后再添加空地址，使空地址能准确添加到栈顶，防止出错
      setTimeout(() => {
        window.addEventListener(
          "popstate",
          (e) => {
            this.removeState();
            if (e.state && e.state.target == "MeanSure") {
              //此处可调用一些自定义的操作，例如弹窗提示之类的，最后根据实际需要可调用上面三个函数中的任何一个，用于决定当前自定义操作完成之后，需要停留在本页面，还是回退，还是跳转到其他页面
              this.showContract = false;
            } else {
              let backCount;
              backCount = -(this.changeNum + 1);
              history.go(backCount);
            }
          },
          false
        );
      }, 500);
    },
    getApiBatchInfo () {
      ApiMethods.ApiBatchSignController.apiBatchInfo(this.query).then((res) => {
        if (!res.success) {
          return this.$message.error(res.description)
        }
        this.signInfo = res.data;
        if (res.data.loginFlag === 2) {
          this.checkSignLogin(this.signInfo)
        } else {
          if (res.data.unableSignCode) {
            this.$message.error(res.data.unableSignMsg);
            this.unableSign = true;
          }
          this.readTime = res.data.readTime; // 强制阅读时间
          let readedList = this.getContractReaded()[this.query.bsNo]; // 获取本地当前流水对应的合同阅读状态
          readedList = readedList ? readedList : [];
          // console.log('存储的已阅读合同信息',this.getContractReaded(),readedList)
          this.contractList = res.data.viewSignList.map((i) => {
            if (readedList.length && readedList.indexOf(i.signNo) > -1) {
              // 标记已经阅读过的合同
              i.read = true;
            } else {
              i.read = false;
            }
            return i;
          });

          this.evidenceTitle = res.data.evidenceTitle;
          this.forceEvidence = res.data.forceEvidence || 0;

          this.handChapteInfo = null;
        }
      });
    },

    showDetail (item,i) {
      this.setContractReaded(this.query.bsNo, item.signNo); // 存储当前流水对应的当前合同为已读
      const _item = JSON.parse(JSON.stringify(item))
      _item.read = true
      this.$set(this.contractList,i,_item)
      this.currentTitle = item.contractName;
      let new_window;
      if (!isInDingTalk) new_window = window.open("", "_blank");
      isInDingTalk ? location.href = item.viewUrl : new_window.location.href = item.viewUrl;
    },
    getQrcode () {
      this.visibleQrcode = true;
      this.qrcodeUrl = `${GlobalConfig.domain.junziqianH5Op}/derong/signInfo/viewDetail?bsNo=${this.query.bsNo}&mId=${this.query.mId}&ts=${this.query.ts}&iden=${this.query.iden}&frompc=true&sign=${this.query.sign}`;
    },
  },
  beforeDestroy () {
  },
};
</script>

<style lang="less" scoped>
.pre-img-box-sty{
  .dia-body{
    text-align: center;
    .pre-img {
      max-width: 100%;
      box-shadow: 0px 0px 10px #ccc;
    }
    .page-item{
      text-align: center;
      margin: 5px;
    }
  }
}
.view-main-h5{
  display: flex;
  justify-content: center;
}
.iframe-sty{
  width:30vw;
  height: 100vh;
}
.el-main {
  padding: 0;
}

.view-main {
  margin-top: 20px;
  background-color: #f5f5f5;
  height: 100%;
}

.option-main {
  position: fixed;
  background-color: #f8f8f8;
  z-index: 2;
  width: 100%;
  bottom: 0;

  .sign-footer {
    height: 50px;
    background: #ffffff;
    box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.1);
    position: relative;
  }
}
.sign-login {
  background: #bbbbbb;

  .sign-login__form {
    width: 390px;

    .select {
      width: 100%;
    }

    h5 {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: -10px;
    }
  }

  .dialog-box {
    box-sizing: border-box;
    margin: -40px -20px -20px -20px;
    background: #ffffff;
    padding: 20px 40px;
    height: 400px;
    box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
  }

  .nav-bar {
    border-bottom: 1px solid #646464;
    margin-bottom: 20px;

    a {
      display: inline-block;
      padding: 6px 16px 6px 0;
      font-size: 18px;
      cursor: pointer;
    }

    a.active {
      color: #ec1c1c;
    }
  }
}
.sign-btn {
  width: 100px;
  height: 30px;
  background: #297fe1;
  opacity: 1;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  position: absolute;
  left: 80%;
  top: 10px;
}

.view-detail {
  width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;

  .p-title {
    height: 50px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    border-bottom: 1px solid #e5e5e5;
    line-height: 50px;
    position: relative;

    i {
      width: 5px;
      height: 15px;
      background: #000000;
      display: inline-block;
      margin-right: 5px;
    }

    .temp {
      font-size: 16px;
      color: #290202;
      position: absolute;
      right: 22px;

      .tempNo {
        font-weight: bold;
        color: #297fe1;
      }
    }
  }

  .contract-list {
    overflow: hidden;

    li {
      overflow: hidden;
      float: left;

      img {
        width: 100%;
        display: inline-block;
      }

      p {
        float: left;
        text-align: center;
        font-size: 0.86rem;
        font-weight: 500;
        color: rgba(101, 101, 101, 1);
        width: 100%;
        margin-top: 0.7rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}

/deep/ .el-dialog__headerbtn {
  top: 0;
  right: 3px;
}
</style>



// WEBPACK FOOTER //
// pages/derong/signInfo/viewDetail.vue